import { useEffect } from "react";

interface ServiceStructuredDataProps {
  serviceName: string;
  serviceDescription: string;
  serviceUrl: string;
  priceRange?: string;
}

const ServiceStructuredData = ({ 
  serviceName, 
  serviceDescription, 
  serviceUrl,
  priceRange 
}: ServiceStructuredDataProps) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "service-structured-data";
    
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": serviceName,
      "description": serviceDescription,
      "url": serviceUrl,
      "provider": {
        "@type": "LocalBusiness",
        "name": "Tolstoï Serrurier",
        "image": "https://www.tolstoi-serrurier.fr/logo.jpg",
        "telephone": "06 95 22 00 18",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Villeurbanne",
          "postalCode": "69100",
          "addressCountry": "FR",
          "addressRegion": "Auvergne-Rhône-Alpes"
        },
        "areaServed": [
          {
            "@type": "City",
            "name": "Villeurbanne"
          },
          {
            "@type": "City",
            "name": "Lyon"
          }
        ],
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
          ],
          "opens": "00:00",
          "closes": "23:59"
        }
      },
      "serviceType": "Serrurerie",
      "availableChannel": {
        "@type": "ServiceChannel",
        "servicePhone": {
          "@type": "ContactPoint",
          "telephone": "06 95 22 00 18",
          "contactType": "customer service",
          "availableLanguage": "French"
        }
      }
    };

    if (priceRange) {
      structuredData["priceRange"] = priceRange;
    }

    script.text = JSON.stringify(structuredData);
    
    // Remove existing script if present
    const existing = document.getElementById("service-structured-data");
    if (existing) {
      existing.remove();
    }
    
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById("service-structured-data");
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [serviceName, serviceDescription, serviceUrl, priceRange]);

  return null;
};

export default ServiceStructuredData;
